import Loadable from "app/components/Loadable";
import React, { lazy } from "react";

const ManageVehicles = Loadable(lazy(() => import("./VehiclesList")));
const AddVehicle = Loadable(lazy(() => import("./AddVehicle")));
const ManageStudent = Loadable(lazy(() => import("./ManageStudent")));
const EditVehicle = Loadable(lazy(() => import("./EditVehicle")));

const manageVehiclesRoutes = [
    { path: "/vehicles/list", element: <ManageVehicles/> },
    { path: '/vehicles/add-vehicle', element: <AddVehicle /> },
    { path: "/vehicles/student-list", element: <ManageStudent/>},
    { path: "/vehicles/edit-vehicle", element: <EditVehicle/> },
];

export default manageVehiclesRoutes;